(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2626],{

/***/ 31549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var app_hooks_lang__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91289);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



var useMetaDescription = function useMetaDescription() {
  var t = (0,app_hooks_lang__WEBPACK_IMPORTED_MODULE_1__/* .useTranslate */ .q)();
  return function (text) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
      name: "description",
      content: text || t("meta.description")
    });
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (useMetaDescription);

/***/ }),

/***/ 52537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var next_dist_client_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69898);
/* harmony import */ var next_dist_client_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_dist_client_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(31194);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var app_hooks_lang__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(91289);
/* harmony import */ var app_hooks_go_back_hook__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71014);
/* harmony import */ var app_context_country_context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91537);
/* harmony import */ var app_components_icons_Loader__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37387);
/* harmony import */ var app_utils_getMetaDescription__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31549);
/* harmony import */ var app_store_store__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4062);
/* harmony import */ var app_store_slices_user__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(38886);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85893);














var Home = function Home() {
  var router = (0,next_dist_client_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();

  var _useCountryContext = (0,app_context_country_context__WEBPACK_IMPORTED_MODULE_4__/* .useCountryContext */ .o)(),
      country = _useCountryContext.country;

  var t = (0,app_hooks_lang__WEBPACK_IMPORTED_MODULE_10__/* .useTranslate */ .q)();

  var _useAppSelector = (0,app_store_store__WEBPACK_IMPORTED_MODULE_7__/* .useAppSelector */ .CG)(app_store_slices_user__WEBPACK_IMPORTED_MODULE_8__/* .selectUserState */ .tH),
      selectedDiscoverLanguage = _useAppSelector.selectedDiscoverLanguage;

  var countryCode = (selectedDiscoverLanguage === null || selectedDiscoverLanguage === void 0 ? void 0 : selectedDiscoverLanguage.permalink.split('/').pop()) || country.countryCode;
  var getMetaDescription = (0,app_utils_getMetaDescription__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    if (countryCode) {
      router.replace("/discover/radio/".concat(countryCode));
    }
  }, [router, countryCode]);
  (0,app_hooks_go_back_hook__WEBPACK_IMPORTED_MODULE_3__/* .useGoBackHistory */ .J)("DISCOVER");
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().container),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("title", {
        children: t("header.menu.discover")
      }), getMetaDescription()]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
      className: "loader fullpage",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(app_components_icons_Loader__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (Home);

/***/ }),

/***/ 55421:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/discover",
      function () {
        return __webpack_require__(52537);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 31194:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","action_button":"discover_action_button__VjlQl","tab":"discover_tab__gymxE","country_wrapper":"discover_country_wrapper__XEEAL","container":"discover_container__AjGCc","header":"discover_header__5JMcz","stations_container":"discover_stations_container__14adM","tabs":"discover_tabs__LEgsQ","tabs_wrapper":"discover_tabs_wrapper__cs6jO","active":"discover_active__IIhAT","country_name":"discover_country_name__PCYPI","country_logo":"discover_country_logo__i7p5E","podcasts_tab":"discover_podcasts_tab__tR9KE","loader":"discover_loader__B0WZi","category_section":"discover_category_section__druVh"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(55421); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);